import { Component } from '@angular/core';
import { ROUTES } from './side-nav-routes.config';
import { ThemeConstantService } from '../../services/theme-constant.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './side-nav.component.html',
  styles: [`
    .side-nav:hover{
        width: 230px
    }
    .side-nav ul{
        height: inherit
    }
    .side-nav .side-nav-menu.ant-menu-submenu-open .ant-menu-submenu:hover > .ant-menu {
        display:none;
    }
    .custom-scroll::-webkit-scrollbar {
    width: 1px;
    height: 1px;
  }
  
  .custom-scroll::-webkit-scrollbar-track {
    background: rgb(255, 255, 255);
  }
  
  .custom-scroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    border: 1px solid rgb(233, 233, 233);
  }

  .custom-scroll::-webkit-scrollbar-thumb:hover {
    background-color: rgb(233, 233, 233);
  } 
    `]
})

export class SideNavComponent {
  public menuItems: any[]
  isFolded: boolean;
  isSideNavDark: boolean;
  isExpand: boolean;
  isHovered: boolean = true;
  currentUser: any;

  constructor(private themeService: ThemeConstantService) {
    if (localStorage.getItem('currentUser')) {
      this.currentUser = localStorage.getItem('currentUser');
    }
  }

  ngOnInit(): void {
    let user = JSON.parse(this.currentUser);
    this.menuItems = this.filterMenuItemsByRoles(ROUTES, user.roleId);
    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
    this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
  }

  closeMobileMenu(): void {
    if (window.innerWidth < 992) {
      this.isFolded = false;
      this.isExpand = !this.isExpand;
      this.themeService.toggleExpand(this.isExpand);
      this.themeService.toggleFold(this.isFolded);
    }
  }
  private filterMenuItemsByRoles(menuItems: any[], roles: string[]): any[] {
    return menuItems.filter(item => {
      if (!item.roles) return true;
      return item.roles.some(role => roles.includes(role));
    }).map(item => ({
      ...item,
      submenu: this.filterMenuItemsByRoles(item.submenu, roles)
    }));
  }
}
